// extracted by mini-css-extract-plugin
export default {"auth-modal":"AuthModal-module__auth-modal--CP5Xz","authModal":"AuthModal-module__auth-modal--CP5Xz"};